// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"layout_mainContainer__FjICN","contentContainer":"layout_contentContainer__fIXue"};